/* esm.sh - d3-transition@3.0.1/src/transition/select */
export * from "/*d3-transition@3.0.1/esnext/src/transition/select.mjs";
export { default } from "/*d3-transition@3.0.1/esnext/src/transition/select.mjs";
